import { useState } from "react"

const useMultiSelect = () => {
   const [selectedItems, setSelectedItems] = useState(new Set())

   const toggleItem = item => {
      if (selectedItems.has(item)) {
         selectedItems.delete(item)
         setSelectedItems(new Set(selectedItems))
      } else {
         setSelectedItems(new Set(selectedItems).add(item))
      }
   }

   const toggleSingleItem = item => {
      setSelectedItems(new Set([item]))
   }

   const clearSelection = () => {
      setSelectedItems(new Set())
   }

   const hasSelectedItem = item => {
      return selectedItems.has(item)
   }

   const deleteItem = item => {
      selectedItems.delete(item)
      setSelectedItems(new Set(selectedItems))
   }

   return {
      selectedItems: Array.from(selectedItems),
      toggleItem,
      toggleSingleItem,
      clearSelection,
      hasSelectedItem,
      deleteItem,
   }
}

export default useMultiSelect
